import * as React from 'react'

export type SpacerProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * The amount of flex-grow the spacer should have.
   * Defaults to 1, meaning it will take up all available space.
   */
  flexGrow?: number
}

/**
 * A Spacer component that expands to fill available space within a flex container.
 * Useful for pushing elements apart.
 *
 * @example
 * <RowFlex>
 *   <span>Left Item</span>
 *   <Spacer />
 *   <span>Right Item</span>
 * </RowFlex>
 */
export const Spacer = React.memo<SpacerProps>(({ flexGrow = 1, style, ...rest }) => {
  const spacerStyle: React.CSSProperties = {
    flexGrow,
    ...style,
  }

  return <div style={spacerStyle} {...rest} />
})

Spacer.displayName = 'Spacer'
